import { i18n } from "services/i18nService";

export const QUANTITY_ON_HAND_NOT_ZERO = "QUANTITY_ON_HAND_NOT_ZERO";
export const ID_NOT_FOUND = "ID_NOT_FOUND";
export const NAME_VALUE_REQUIRED = "NAME_VALUE_REQUIRED";
export const DUPLICATE_NAME = "DUPLICATE_NAME";
export const OVER_DEPARTMENT_CLASS_LIMIT = "OVER_DEPARTMENT_CLASS_LIMIT";

export function getErrorCodeMessage(errorCode, details) {
  switch (errorCode) {
    case QUANTITY_ON_HAND_NOT_ZERO:
      const messages = details.map(({ item, locations }) => {
        const locationNames = locations.map(({ name }) => name).join(", ");
        return `${item.name} (Locations: ${locationNames})`;
      });
      return `${i18n("errorCode.QUANTITY_ON_HAND_NOT_ZERO")} ${messages.join(
        "; "
      )};`;
    case ID_NOT_FOUND:
      return i18n("global.SomethingWentWrong");
    case NAME_VALUE_REQUIRED:
      return i18n("errorCode.NAME_VALUE_REQUIRED");
    case DUPLICATE_NAME:
      return i18n("errorCode.DUPLICATE_NAME");
    case OVER_DEPARTMENT_CLASS_LIMIT:
      return i18n(
        details > 0
          ? "errorCode.OVER_DEPARTMENT_CLASS_LIMIT_OVER_ZERO"
          : "errorCode.OVER_DEPARTMENT_CLASS_LIMIT_ZERO",
        {
          limit: details,
        }
      );

    default:
      return null;
  }
}
